import type { PermissionCatalog } from '@ztechapps/common.contract'
import { appShellPermissions } from '@ztechapps/common.contract'
import { aiPermissions } from '@ztechapps/ai.common'
import { customerPermissions } from '@ztechapps/customer.common'
import { driverPermissions } from './driverPermissions'
import { haulerPermissions } from './haulerPermissions'
import { milkTicketPermissions } from './milkTicketPermissions'
import { routePermissions } from './routePermissions'

// driverPermissions.isDriver is intentionally omitted — it is granted programmatically at
// driver registration and is never offered as a checkbox on this grant screen.
export const haulerPermissionCatalog: PermissionCatalog = [
  {
    label: 'Hauler',
    permissions: [haulerPermissions.canAccess],
  },
  {
    label: 'Milk Ticket',
    permissions: [
      milkTicketPermissions.canView,
      milkTicketPermissions.canEdit,
      milkTicketPermissions.canDelete,
      milkTicketPermissions.canPrintManifest,
      milkTicketPermissions.canSignManifest,
      milkTicketPermissions.canSignPickups,
    ],
  },
  {
    label: 'Customers',
    permissions: [customerPermissions.canView, customerPermissions.canEdit, customerPermissions.canDelete],
  },
  {
    label: 'Drivers',
    permissions: [driverPermissions.canView, driverPermissions.canEdit, driverPermissions.canDelete],
  },
  {
    label: 'Routes',
    permissions: [routePermissions.canView, routePermissions.canEdit, routePermissions.canDelete],
  },
  {
    label: 'History',
    permissions: [appShellPermissions.history.canView],
  },
  {
    label: 'Settings',
    permissions: [appShellPermissions.setting.canView, appShellPermissions.setting.canEdit],
  },
  {
    label: 'AI Billing',
    permissions: [aiPermissions.canManageAiBilling],
  },
]
